import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetZoomIntegration as GetZoomIntegrationQuery} from 'nutshell-graphql-types';

import GET_ZOOM_INTEGRATION from '../queries/get-zoom-integration.graphql';

export const useGetZoomIntegration = () => {
    const {data, error, loading, refetch, startPolling, stopPolling} = useQuery<
        GetZoomIntegrationQuery,
        Record<any, any>
    >(GET_ZOOM_INTEGRATION, {
        fetchPolicy: 'cache-and-network',
    });

    const isLoading = loading && !data;
    const loggedInUser = data ? data.loggedInUser : null;

    return {
        zoomIntegration: loggedInUser ? loggedInUser.zoomIntegration : null,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
        startPolling,
        stopPolling,
    };
};
